import React, { useState, useEffect, useContext } from 'react';
import { motion } from 'framer-motion';
import { useParams, useNavigate } from 'react-router-dom';

import Button from '../../shared/components/FormElements/Button/Button';
import Modal from '../../shared/components/UIElements/Modal';
import QuestionList from '../components/QuestionList';
import MainNavigation from '../../components/MainNavigation';
import ErrorModal from '../../shared/components/UIElements/ErrorModal';
import LoadingSpinner from '../../shared/components/UIElements/LoadingSpinner';
import { useHttpClient } from '../../shared/hooks/http-hook';
import { AuthContext } from '../../shared/context/auth-context';
import './InterviewQuestions.css';
import LineChart from '../components/LineChart';

const InterviewQuestions = props => {
    const navigate = useNavigate();
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const interviewId = useParams().interviewId;
    const auth = useContext(AuthContext);
    const [loadedQuestions, setLoadedQuestions] = useState();
    const [loadedInterview, setLoadedInterview] = useState();
    const { isLoading, error, sendRequest, clearError } = useHttpClient();
    const [scoreData, setScoreData] = useState();
    const [plan, setPlan] = useState('free');

    const showDeleteModalHandler = () => {
        setShowDeleteModal(true);
    };

    const closeDeleteModalHandler = () => {
        setShowDeleteModal(false);
    };

    const confirmDeletionHandler = async () => {
        setShowDeleteModal(false);
        try {
            await sendRequest(process.env.REACT_APP_BACKEND_URL_PLAN+`/interview/${interviewId}/delete`, 'DELETE', null, {Authorization:'Bearer '+auth.token});
            props.onDelete(props.id);
        } catch (err) {

        }
        navigate('/home')
    };


    useEffect(()=>{
        const fetchQuestions = async () => {
            try {

                const responseData = await sendRequest(process.env.REACT_APP_BACKEND_URL_PLAN+`/interview/${interviewId}/questions`, 'GET', null, {Authorization:'Bearer '+ auth.token});

                setLoadedQuestions(responseData.questions);
                setLoadedInterview(responseData.interview);
                setPlan(responseData.plan);

                let avgScoreRecord = responseData.interview.avgScoreRecord;
                if (avgScoreRecord.length > 10) {
                    avgScoreRecord = responseData.interview.avgScoreRecord.slice(-10);
                }
                setScoreData({
                    labels: avgScoreRecord.map((data) => {
                        return new Date(data.date).toLocaleDateString()
                    }),
                    datasets: [
                        {
                            label: 'Average',
                            data: avgScoreRecord.map((data) => {
                                return data.avgScore
                            }),
                            borderColor: 'rgb(110, 111, 247, 1)',
                            backgroundColor: (context) => {
                                const bgColor = [
                                    'rgb(110, 111, 247, 0.8)',
                                    'rgb(110, 111, 247, 0.6)',
                                    'rgb(110, 111, 247, 0.4)',
                                    'rgb(110, 111, 247, 0.2)',
                                ]
            
                                if (!context.chart.chartArea) {
                                    return;
                                }
                                const { ctx, data, chartArea:{top, bottom} } = context.chart;
                                const gradientBg = ctx.createLinearGradient(0, top, 0, bottom);
                                gradientBg.addColorStop(0, bgColor[0]);
                                gradientBg.addColorStop(0.33, bgColor[1]);
                                gradientBg.addColorStop(0.66, bgColor[2]);
                                gradientBg.addColorStop(1, bgColor[3]);
            
                                return gradientBg;
                            },
                            fill: true
                        }
                    ]
                });

            } catch (err) {}
        };
        fetchQuestions();
    },[sendRequest, interviewId, auth.token]);

    const questionDeleteHandler = (deletedQuestionId) => {
        setLoadedQuestions(prevQuestions=>prevQuestions.filter(question => question.id !== deletedQuestionId));
      };

    return <React.Fragment>
        <Modal
        show={showDeleteModal}
        onCancel={closeDeleteModalHandler}
        header="Are you sure?"
        footerClass="interview-item__modal-actions"
        footer={
        <React.Fragment>
            <Button inverse onClick={closeDeleteModalHandler}>
            CANCEL
            </Button>
            <Button danger onClick={confirmDeletionHandler}>
            DELETE
            </Button>
        </React.Fragment>
        }
        >
            <p>You can never undo delete. Are you sure you want to delete the interview?</p>
        </Modal>
        {!isLoading && <MainNavigation />}
        <div className='interviewquestion-page'>
        <ErrorModal error={error} onClear={clearError}/>
        {isLoading && <LoadingSpinner asOverlay />}
        {!isLoading && loadedInterview && <motion.div 
            className="planmodules-description"
            initial={{ opacity: 0, scale: 1 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ delay: 0.25, duration: 0.5 }}
            exit={{ opacity: 0, scale: 1 }}
        >
            <div className='delete-wrapper'>
                <h1>{loadedInterview.title}</h1>
                
            </div>
        <p>Select a question to answer and receive feedback on. </p>
        </motion.div>}
        {!isLoading && loadedQuestions && (plan === 'free') && <motion.div 
                className='questions-details'
                initial={{ opacity: 0, scale: 1 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.25, duration: 0.5 }}
                exit={{ opacity: 0, scale: 1 }}
            >
                <div className='questions-list-wrapper'>
                    <h3>Questions:</h3>
                    <QuestionList items={loadedQuestions} onDeleteQuestion={questionDeleteHandler} />
                </div>
                <div className='question-chart'>
                    <h3>Progress:</h3>
                    <div className='chart-div-free'>
                        <LineChart chartData={scoreData} options={{responsive: true}}/>
                    </div>
                </div>
            </motion.div>}
            {!isLoading && loadedQuestions && (plan === 'pro') && <motion.div 
                className='questions-details'
                initial={{ opacity: 0, scale: 1 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{ delay: 0.25, duration: 0.5 }}
                exit={{ opacity: 0, scale: 1 }}
            >
                <div className='questions-list-wrapper'>
                    <h3>Questions:</h3>
                    <QuestionList items={loadedQuestions} onDeleteQuestion={questionDeleteHandler} />
                </div>
                <div className='question-chart'>
                    <h3>Progress:</h3>
                    <div className='chart-div'>
                        <LineChart chartData={scoreData} options={{responsive: true}}/>
                    </div>
                </div>
            </motion.div>}
        </div>
        </React.Fragment>;
};

export default InterviewQuestions;